var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlignLeft = function SvgAlignLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 13,
    viewBox: "0 0 19 13"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M0 0h19v3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#055D7F",
    d: "M0 5h10v3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M0 10h13v3H0z"
  }))));
};
export default SvgAlignLeft;